import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-match-information',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton-match-information.component.html',
})
export class SkeletonMatchInformationComponent {}
